import { BadgeContainer } from './style';

interface IForexBadgeComponent {
	text: string;
}
export const Badge = (props: IForexBadgeComponent) => {
	return <BadgeContainer>{props.text}</BadgeContainer>;
};
